"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const webjs_sdk_1 = require("@aria/webjs-sdk");
const config_1 = require("config");
const BaseRestClient_1 = require("./BaseRestClient");
function transform(model) {
    return {
        action: 'Chat',
        flowId: model.flowId,
        id: model.longId,
        resource: model.threadId,
    };
}
const transformWrapper = (shortId) => (model) => ({
    ...transform(model),
    shortId,
});
class MeetingsApiClient extends BaseRestClient_1.BaseRestClient {
    joinAsGuest(payload) {
        return this.performApiPost(`/v1/meetings/${payload.shortId}/members`, {
            displayName: payload.name,
        }, {
            eventProperties: {
                priority: webjs_sdk_1.AWTEventPriority.Immediate_sync,
                genericEventPath: '/v1/meetings/{shortId}/members',
                customPropertiesProvider: () => {
                    return {
                        includesCaptcha: !!payload.captcha,
                    };
                },
            },
        });
    }
    getConversation(payload) {
        const shortId = payload.shortId;
        return this.performApiGet(`/v1/meetings/${shortId}`, {
            eventProperties: {
                genericEventPath: '/v1/meetings/{shortId}',
            },
        }).then(transformWrapper(shortId));
    }
}
exports.default = new MeetingsApiClient(config_1.default.urls.api.meetings);
